import {createContext, useEffect, useState} from "react";

export const LoginContext = createContext();

export function LoginProvider(props) {
  const [user, setUser] = useState();

  useEffect(() => {
    let user = localStorage.getItem('user');
    if(user){
      setUser(JSON.parse(user));
    }
  }, [])

  return (
    <LoginContext.Provider value={{user, setUser}}>
      {props.children}
    </LoginContext.Provider>
  )
}
